import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import style from './index.scss';
import { parseColumnsForMatchingConfigListing } from './utli';
import { getAttributeByResourceCode } from '../../../../util/miscellaneousUtils';

import { MODULE_SOURCEID_MAPPING } from '../../../../util/GlobalConstant';
import { get } from '../../../../util/lodashlike';

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG';

export const NSMatchingConfigListing = (props) => {
  const {
    matchingConfigListData,
    GSConfigMatchingListing,
    apiActions,
    authentication
  } = props;
  const { getNSMatchingConfigListData } = apiActions;

  const { isLoading, error, data } = matchingConfigListData;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const sourceId =
    MODULE_SOURCEID_MAPPING[
      get(authentication, 'currentProductLogin.moduleCode')
    ] || '';

  useEffect(() => {
    getNSMatchingConfigListData({
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      sourceId
    });
  }, [pageSize, currentPage]);

  const onPaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const columns = parseColumnsForMatchingConfigListing(
    GSConfigMatchingListing && GSConfigMatchingListing.widgetConfig,
    apiActions
  );

  return (
    <div className={style.wrapper}>
      {GSConfigMatchingListing?.isVisible && (
        <React.Fragment>
          <div className={style.heading}>List of Matching Configurations</div>
          <Table
            id="matchingConfigList"
            className={style.table}
            dataSource={data?.payload}
            columns={columns}
            loading={isLoading}
            rowKey="id"
            pagination={{
              showSizeChanger: true,
              responsive: false,
              total: data?.total,
              current: currentPage,
              pageSize,
              onChange: onPaginationChange,
              pageSizeOptions: [5, 10, 25, 50, 100],
              showTotal: (total) => `${total} Records`
            }}
            scroll={{ y: 240 }}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default NSMatchingConfigListing;
